<template>
  <div class="loader-infinity-more">
    <div class="loader-infinity-more__bar"></div>
  </div>
</template>

<script>
  export default {
    name: 'LoaderInfinityMore',
  };
</script>

<style lang="scss" scoped>
  .loader-infinity-more {
    height: 4px;
    width: 100%;
    background-color: $light-grey-7;
    border-radius: 2px;
    overflow: hidden;

    &__bar {
      height: 100%;
      background: linear-gradient(90deg, $blue, $blue-2);
      border-radius: 2px;
      animation: loading 1.5s ease infinite;
    }

    @keyframes loading {
      0% {
        width: 0;
        transform: translateX(-100%);
      }
      100% {
        width: 100%;
        transform: translateX(100%);
      }
    }
  }
</style>
